module.exports = __webpack_public_path__ + "static/img/hot-intro-img-m.81c1593.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hot-intro-img-m.png
// module id = v94b
// module chunks = 2